var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg0203D(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1000,
    height: 561,
    viewBox: "0 0 1000 561",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n        stroke: #000;\r\n        stroke-width: 20px;\r\n        fill-rule: evenodd;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M90,159V41l313-1,1,85s-53.885,64.152-90,106c136.066,0,180.158,291-69,291-102.676,0-154.457-32.946-179-45,10.412-23.1,32.38-71.732,46-101,44.09,21.012,80.613,39,121,39s69-12.676,69-53-47.13-43-61-43H183V236l78-91H159.427"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M489,162V41H699c122.032,0,239,84.078,239,221S862.372,514,702,514H488V200H612V406h86c55.869,0,116-31.092,116-141S720.143,148,699,148H576.013"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg0203D);
export default __webpack_public_path__ + "static/media/020_3D.e95bc083f93c9a24012e1cf187d3ab09.svg";
export { ForwardRef as ReactComponent };